"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../../types");
const web_ui_1 = require("@gibme/web-ui");
const moment_1 = __importDefault(require("moment"));
const api_1 = __importDefault(require("../api"));
const crypto_1 = require("../../crypto");
const common_1 = require("../common");
const show_edit_client_modal = (record) => {
    web_ui_1.ModalHelper.once('shown', () => __awaiter(void 0, void 0, void 0, function* () {
        web_ui_1.ModalHelper.select('#edit_client_first_name').val(record.first_name);
        web_ui_1.ModalHelper.select('#edit_client_last_name').val(record.last_name);
        web_ui_1.ModalHelper.select('#edit_client_mobile').val((0, common_1.formatPhone)(record.mobile || ''));
        web_ui_1.ModalHelper.select('#edit_client_dob').val(moment_1.default.utc(record.birthday).format('YYYY-MM-DD'));
        const table = (0, web_ui_1.createDataTable)(web_ui_1.ModalHelper.select('#edit_client_file_list'), {
            paging: false,
            searching: false,
            responsive: true,
            language: {
                emptyTable: 'Client does not have any files available.'
            },
            columnDefs: [
                {
                    targets: [0],
                    orderable: false,
                    className: 'text-center w-header-sm'
                },
                {
                    targets: [1],
                    orderable: false,
                    render: (record, type) => {
                        if (type === 'display') {
                            return (0, types_1.FileTypeName)(record);
                        }
                        return record.valueOf();
                    }
                },
                {
                    targets: [2],
                    className: 'text-center w-button',
                    orderable: false,
                    searchable: false,
                    render: (record, type) => {
                        if (type === 'display') {
                            return (0, web_ui_1.fetchHTML)((0, web_ui_1.createAwesomeButton)('file-arrow-down')
                                .addClass('btn btn-sm btn-success')
                                .attr('onclick', `handle_file_download('${(0, crypto_1.hash)(record)}')`));
                        }
                        return '';
                    }
                },
                {
                    targets: [3],
                    className: 'text-center w-button',
                    orderable: false,
                    searchable: false,
                    render: (record, type) => {
                        if (type === 'display') {
                            return (0, web_ui_1.fetchHTML)((0, web_ui_1.createAwesomeButton)('xmark')
                                .addClass('btn btn-sm btn-danger')
                                .attr('onclick', `handle_file_delete('${(0, crypto_1.hash)(record)}')`));
                        }
                        return '';
                    }
                }
            ],
            order: [[0, 'desc'], [1, 'asc']]
        }).draw()
            .columns.adjust()
            .responsive.recalc();
        const uploads_table = (0, web_ui_1.createDataTable)(web_ui_1.ModalHelper.select('#edit_client_uploaded_file_list'), {
            paging: true,
            searching: true,
            pageLength: 5,
            language: {
                emptyTable: 'No files have been uploaded by the client'
            },
            columnDefs: [
                {
                    targets: [0],
                    render: (record) => {
                        return record;
                    }
                },
                {
                    targets: [1],
                    className: 'w-button-lg',
                    render: (record, type) => {
                        if (type === 'display' || type === 'filter') {
                            return (0, moment_1.default)(record).format('MM/DD/YYYY');
                        }
                        return (0, moment_1.default)(record).unix();
                    }
                },
                {
                    targets: [2],
                    orderable: false,
                    searchable: false,
                    className: 'text-center w-button',
                    render: (record, type) => {
                        if (type === 'display') {
                            const button = (0, web_ui_1.createAwesomeButton)('file-arrow-down')
                                .addClass('btn btn-sm btn-success')
                                .attr('onclick', `handle_client_file_download('${(0, crypto_1.hash)(record)}')`);
                            return (0, web_ui_1.fetchHTML)(button);
                        }
                        return '';
                    }
                },
                {
                    targets: [3],
                    className: 'text-center w-button',
                    orderable: false,
                    searchable: false,
                    render: (record, type) => {
                        if (type === 'display') {
                            return (0, web_ui_1.fetchHTML)((0, web_ui_1.createAwesomeButton)('xmark')
                                .addClass('btn btn-sm btn-danger')
                                .attr('onclick', `handle_client_file_delete('${(0, crypto_1.hash)(record)}')`));
                        }
                        return '';
                    }
                }
            ],
            order: [[1, 'desc']]
        }).draw()
            .columns.adjust()
            .responsive.recalc();
        const cache = new Map();
        const upload_cache = new Map();
        window.handle_file_download = (hash) => {
            const _record = cache.get(hash);
            if (!_record) {
                return;
            }
            api_1.default.downloadFile(_record);
        };
        window.handle_client_file_download = (hash) => {
            const _record = upload_cache.get(hash);
            if (!_record) {
                return;
            }
            api_1.default.downloadClientFile(_record);
        };
        window.handle_client_file_delete = (hash) => __awaiter(void 0, void 0, void 0, function* () {
            const _record = upload_cache.get(hash);
            if (!_record) {
                return;
            }
            if (!confirm(`Are you sure you wish to delete ${_record.display_name}?`)) {
                return false;
            }
            try {
                web_ui_1.LoadingOverlay.show();
                if (yield api_1.default.deleteClientFile(_record)) {
                    return web_ui_1.ModalHelper.modal().trigger('refresh');
                }
                web_ui_1.LoadingOverlay.hide();
                return web_ui_1.StatusModal.show({
                    title: 'An Error Occurred!',
                    body: 'An error occurred! Please try again!'
                });
            }
            catch (error) {
                web_ui_1.LoadingOverlay.hide();
                return web_ui_1.StatusModal.show({
                    title: 'An Error Occurred!',
                    body: 'An error occurred! Please try again!'
                });
            }
        });
        window.handle_file_delete = (hash) => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            const _record = cache.get(hash);
            if (!_record) {
                return;
            }
            if (!confirm(`Are you sure you wish to delete the ${_record.year} ` +
                `${(0, types_1.FileTypeName)((_a = _record.type) !== null && _a !== void 0 ? _a : 1)} for ${record.first_name} ${record.last_name}`)) {
                return false;
            }
            try {
                web_ui_1.LoadingOverlay.show();
                if (yield api_1.default.deleteFile(_record)) {
                    return web_ui_1.ModalHelper.modal().trigger('refresh');
                }
                web_ui_1.LoadingOverlay.hide();
                return web_ui_1.StatusModal.show({
                    title: 'An Error Occurred!',
                    body: 'An error occurred! Please try again!'
                });
            }
            catch (error) {
                web_ui_1.LoadingOverlay.hide();
                return web_ui_1.StatusModal.show({
                    title: 'An Error Occurred!',
                    body: 'An error occurred! Please try again!'
                });
            }
        });
        const card = web_ui_1.ModalHelper.modal()
            .on('refresh', () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                web_ui_1.LoadingOverlay.show();
                {
                    const records = yield api_1.default.listFiles(record.id);
                    table.clear();
                    cache.clear();
                    for (const record of records) {
                        table.row.add([
                            record.year,
                            record.type,
                            record,
                            record
                        ]);
                        cache.set((0, crypto_1.hash)(record), record);
                    }
                }
                {
                    const records = yield api_1.default.listClientUploads(record.id);
                    uploads_table.clear();
                    upload_cache.clear();
                    for (const record of records) {
                        uploads_table.row.add([
                            record.display_name,
                            record.timestamp,
                            record,
                            record
                        ]).draw();
                        upload_cache.set((0, crypto_1.hash)(record), record);
                    }
                }
            }
            finally {
                table.draw()
                    .columns.adjust()
                    .responsive.recalc();
                uploads_table.draw()
                    .columns.adjust()
                    .responsive.recalc();
                web_ui_1.LoadingOverlay.hide();
            }
        }));
        web_ui_1.ModalHelper.select('#edit_client_secret_checkbox').on('change', event => {
            const target = (0, web_ui_1.$)(event.target);
            if (target.is(':checked')) {
                web_ui_1.ModalHelper.select('#edit_client_secret')
                    .removeProp('disabled')
                    .removeAttr('disabled');
            }
            else {
                web_ui_1.ModalHelper.select('#edit_client_secret')
                    .prop('disabled', 'disabled')
                    .attr('disabled', 'disabled');
            }
        });
        web_ui_1.ModalHelper.select('#edit_client_secret').on('change keyup', event => {
            return (0, common_1.checkSSN)((0, web_ui_1.$)(event.target));
        });
        web_ui_1.ModalHelper.select('#edit_client_dob').on('change keyup', event => {
            return (0, common_1.checkDate)((0, web_ui_1.$)(event.target));
        });
        web_ui_1.ModalHelper.select('#edit_client_button').on('click', () => __awaiter(void 0, void 0, void 0, function* () {
            const first_name_field = web_ui_1.ModalHelper.select('#edit_client_first_name');
            const last_name_field = web_ui_1.ModalHelper.select('#edit_client_last_name');
            const mobile_field = web_ui_1.ModalHelper.select('#edit_client_mobile');
            const dob_field = web_ui_1.ModalHelper.select('#edit_client_dob');
            const isChecked = web_ui_1.ModalHelper.select('#edit_client_secret_checkbox')
                .is(':checked');
            const secret_field = web_ui_1.ModalHelper.select('#edit_client_secret');
            const first_name = first_name_field.val().trim();
            const last_name = last_name_field.val().trim();
            const mobile = mobile_field.val().trim();
            const secret = secret_field.val().trim();
            const _dob = dob_field.val().trim();
            if (_dob.length === 0) {
                return dob_field.addClass('is-invalid');
            }
            else {
                dob_field.removeClass('is-invalid');
            }
            if (isChecked && !secret.match(/[0-9]{9}/)) {
                return secret_field.addClass('is-invalid');
            }
            else {
                secret_field.removeClass('is-invalid');
            }
            const dob = moment_1.default.utc(_dob);
            if (dob.isBefore('1899-12-31')) {
                return dob_field.addClass('is-invalid');
            }
            try {
                web_ui_1.LoadingOverlay.show();
                const _record = {
                    id: record.id,
                    first_name,
                    last_name,
                    mobile,
                    birthday: dob.toDate()
                };
                if (isChecked) {
                    _record.ssn = secret;
                }
                const result = yield api_1.default.updateClient(_record);
                if (result === types_1.HTTPError.CREATED) {
                    (0, web_ui_1.$)('#staff-portal-card').trigger('refresh');
                    return web_ui_1.ModalHelper.close();
                }
                web_ui_1.LoadingOverlay.hide();
                return web_ui_1.StatusModal.show({
                    title: 'Invalid Credentials Supplied',
                    body: 'Please check your information and try again'
                });
            }
            catch (_b) {
                web_ui_1.LoadingOverlay.hide();
            }
        }));
        card.trigger('refresh');
    }));
    web_ui_1.ModalHelper.open({
        title: 'Edit Client',
        body: (0, web_ui_1.$)('#edit_client_modal').clone()
            .removeClass('d-none'),
        scrollable: true
    });
    web_ui_1.ModalHelper.select('#edit_client_upload_button').on('click', () => __awaiter(void 0, void 0, void 0, function* () {
        const file_input = web_ui_1.ModalHelper.select('#edit_client_file');
        const year_input = web_ui_1.ModalHelper.select('#edit_client_year');
        const type_input = web_ui_1.ModalHelper.select('#edit_client_type');
        try {
            web_ui_1.LoadingOverlay.show();
            const [contents, name] = yield (0, common_1.readFileInputField)(file_input);
            const payload = {
                file: {
                    contents,
                    name
                },
                client_id: record.id,
                year: parseInt(year_input.val() || '0') || 0,
                type: parseInt(type_input.val() || '0') || 0
            };
            const status = yield api_1.default.uploadFile(payload);
            if (status === types_1.HTTPError.CREATED) {
                file_input.val('');
                year_input.val((new Date()).getFullYear());
                type_input.val(types_1.FileType.Return);
                return web_ui_1.ModalHelper.modal().trigger('refresh');
            }
            web_ui_1.LoadingOverlay.hide();
            return web_ui_1.StatusModal.show({
                title: 'An Error Occurred!',
                body: 'An error occurred! Please try again!'
            });
        }
        catch (error) {
            web_ui_1.LoadingOverlay.hide();
            return web_ui_1.StatusModal.show({
                title: 'An Error Occurred!',
                body: 'An error occurred! Please try again!'
            });
        }
    }));
};
exports.default = show_edit_client_modal;
